<div class={`main-line-row move-list-row ${bgColorClass}`} data-whole-move-number={wholeMoveNumber}>
  {wholeMoveNumber}.

  {#each $moveListRow.content as moveListNode}
    {#if singleMove && is(moveListNode.node.color, 2)}
      <EmptyPly color="white"/>
    {/if}

    <Ply node={moveListNode.node} className="main-line-ply" staticAnnotationIconSpacing={true} />

    {#if singleMove && is(moveListNode.node.color, 1) && hasMainlineRowAfter}
      <EmptyPly color="black"/>
    {/if}
  {/each}

  {#each $moveListRow.content as moveListNode}
    {#if showTimestampForNode(moveListNode)}
      <Timestamp
        timestamp={getTimestampFromNode(moveListNode.node)}
        color={getColorAsWord(moveListNode.node.color)}
        ply={moveListNode.node.ply}
      />
    {/if}
  {/each}
</div>

<svelte:options immutable/>

<script lang="ts">
import type { MoveListComponent } from 'components/move-list/config/types';
import Ply from 'components/move-list/components/ply.svelte';
import { getColorAsWord } from 'chessboard/model/game/get-color-as-word';
import Timestamp from 'components/move-list/components/timestamp.svelte';
import { getTimestampFromNode } from 'chessboard/model/move/get-timestamp-from-node';
import { getContext } from 'svelte';
import { MoveListPlugin } from 'chessboard/plugins/move-list/config/types';
import { is } from 'src/utils/svelte/assertions';
import type { Data } from 'src/utils/svelte/data';
import { getWholeMoveNumber } from '../helpers/move-list-node-utils';
import type { ContextShape } from '../store/types';
import EmptyPly from './empty-ply.svelte';

export let moveListRow: Data<MoveListComponent.Row<MoveListComponent.MoveListNode[]>>;
export let showTimestamps: boolean;
export let hasMainlineRowAfter: boolean;

const { store } = getContext<ContextShape>(MoveListPlugin.Name);
const { startingMoveNumber } = store;

$: singleMove = $moveListRow.content.length === 1;
$: wholeMoveNumber = getWholeMoveNumber($moveListRow.content[0].node, $startingMoveNumber);
$: bgColorClass = $moveListRow.rowBgColor ?? 'light-row';

/**
 * determines if timestamps should be shown for the node
 */
function showTimestampForNode(moveListNode: MoveListComponent.MoveListNode) {
  return showTimestamps && moveListNode?.node?.commands?.timestamp !== undefined;
}
</script>
